import type { FC } from 'react';
import React from 'react';

import { useTranslation } from 'react-i18next';

import { MuiButton } from '@shared/ui-kit';

import { ButtonWrap, CardBottomButtonsContainer, MiddleLine } from './CardBottomButtons.style';

type Props = {
  handleDecline: () => void;
  handleAccept: () => void;
};

export const CardBottomButtons: FC<Props> = ({ handleDecline, handleAccept }) => {
  const { t } = useTranslation();

  return (
    <CardBottomButtonsContainer>
      <ButtonWrap>
        <MuiButton
          color="error"
          variant="text"
          label={t('general.buttons.decline')}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleDecline();
          }}
          fullWidth
          size="small"
        />
      </ButtonWrap>

      <MiddleLine />
      <ButtonWrap>
        <MuiButton
          color="primary"
          variant="text"
          label={t('general.buttons.accept')}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleAccept();
          }}
          fullWidth
          size="small"
        />
      </ButtonWrap>
    </CardBottomButtonsContainer>
  );
};
